module.exports = __webpack_public_path__ + "static/media/Egyptian Queen.c10a9009.jpg";